import type { PublishBlocker } from '@repo/api-contracts';

/** 발행 가드 미충족 사유의 표시 라벨 — 목록·에디터가 공유한다. */
export const BLOCKER_LABELS: Record<PublishBlocker, string> = {
  NO_CATEGORY: '카테고리 연결 없음',
  NO_PRICE_TIER: '가격 구간 없음',
  NO_MEASUREMENT: '실측 규격 없음',
};
